<div class="form-group mb-3">
  <label *ngIf="label" class="form-label">
    {{ label }}
    <span *ngIf="required" class="text-danger">*</span>
  </label>

  <input
    [type]="type"
    class="form-control"
    [class.is-invalid]="errorMessage"
    [placeholder]="placeholder"
    [required]="required"
    [disabled]="disabled"
    [value]="value"
    [attr.inputmode]="inputMode"
    [attr.maxlength]="maxLengthAttr"
    (input)="onInputChange($event)"
    (blur)="onInputBlur()"
  />

  <small *ngIf="helperText && !errorMessage" class="form-text text-muted">
    {{ helperText }}
  </small>

  <div *ngIf="errorMessage" class="invalid-feedback d-block">
    {{ errorMessage }}
  </div>
</div>
